import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withImageOptimizer } from 'Utils/Content';
import { SectionTitle } from 'Components/Titles';
import { SmartLink } from 'Components/SmartLink';
import FeatureImage from 'Components/FeatureImage';
import { WatchNowButton } from 'Components/WatchNowButton';
import { GetAppButton } from 'Components/FreeFormPanels/GetAppButton';
import { device } from 'device.js';
import { Markdown } from 'Components/Markdown';
import './ButtonCTA.css';

const getCtaComponent = (ctaText, screenName, confirmationScreen, url) => {
  if (ctaText && screenName && screenName === confirmationScreen) {
    return (
      <Fragment>
        <GetAppButton ctaText="Get The App" isMobile={device.mobile} />
        <WatchNowButton buttonText="Start Watching" isMobile={device.mobile} />
      </Fragment>
    );
  }
  if (ctaText) {
    return <SmartLink text={ctaText} linkUrl={url} className="ButtonCTALink" reload />;
  }
  return null;
};

export const ButtonCTAComponent = ({ headline, description, ctaText, url, image, screenName, confirmationScreen }) => {
  const defaultRenderer = {
    paragraph: ({ children }) => <span className="ButtonCTADescription">{children}</span>,
  };

  if (device.mobile) {
    return (
      <div className="ButtonCTA">
        <div className="ButtonCTABackgroundContainer">
          <h3 className="MobileSectionTitle">{headline}</h3>
          <div className="MobileCTADescriptionContainer">
            Go mobile with Fox Nation. Our official app makes it easy to watch anywhere!
          </div>
        </div>
        {getCtaComponent(ctaText, screenName, confirmationScreen, url)}
      </div>
    );
  }

  return (
    <div className="ButtonCTA">
      <SectionTitle text={headline} align="center" />
      {description && (
        <Markdown className="ButtonCTADescriptionContainer" source={description} renderers={defaultRenderer} />
      )}
      {image && <FeatureImage url={url} src={withImageOptimizer(image)} srcSet="" />}
      {getCtaComponent(ctaText, screenName, confirmationScreen, url)}
    </div>
  );
};

const mapStateToProps = ({ appConfig: { screens } }) => ({
  confirmationScreen: screens && screens.confirmationScreen,
});

export const ButtonCTA = connect(mapStateToProps)(ButtonCTAComponent);
